/**
 * Moves main-product collapsible content blocks flagged with [data-move-to-details]
 * below the blocks of the Product Details section on desktop (>= 769px), and back to
 * their original position in the product info column on mobile.
 *
 * Disabled in the theme editor (design mode) so blocks stay in their natural position
 * for selection/editing and section re-renders cannot orphan or duplicate moved nodes.
 *
 * On variant changes the nodes are returned home before the variant fetch response is
 * applied (variant-picker.js updateContent only swaps nodes it finds within their own
 * section), then moved again after the change is announced.
 */
if (!window.productDetailsMoveInitialized) {
  window.productDetailsMoveInitialized = true;

  if (!window.Shopify || !window.Shopify.designMode) {
    (() => {
      const mq = window.matchMedia('(min-width: 769px)');
      const markers = new Map();

      const getTarget = () => document.querySelector('.cc-product-details [data-moved-blocks-target]');

      const moveOut = () => {
        const target = getTarget();
        if (!target) return;
        document.querySelectorAll('.cc-main-product [data-move-to-details]').forEach((el) => {
          if (!markers.has(el)) {
            const marker = document.createElement('span');
            marker.hidden = true;
            el.before(marker);
            markers.set(el, marker);
          }
          target.appendChild(el);
        });
      };

      const moveHome = () => {
        markers.forEach((marker, el) => {
          if (marker.isConnected && el !== marker.nextElementSibling) marker.after(el);
        });
      };

      const sync = () => {
        if (mq.matches) {
          moveOut();
        } else {
          moveHome();
        }
      };

      mq.addEventListener('change', sync);

      // Return nodes home before a variant/product fetch response replaces section
      // content, re-sync once the change has been applied and announced.
      document.addEventListener('change', (evt) => {
        if (evt.target.closest && evt.target.closest('variant-picker')) moveHome();
      }, true);
      document.addEventListener('on:variant:change', () => {
        setTimeout(sync, 20);
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', sync, { once: true });
      } else {
        sync();
      }
    })();
  }
}
